import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'shared-ui-modal-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css'],
  standalone: false,
})
export class DeleteModalComponent extends BaseModalComponent {
  @Input() body?: string;

  constructor(activeModal: NgbActiveModal) {
    super(activeModal);

    this.confirmButtonTitle = 'Delete';
  }
}
